// import React from 'react';
// import Testimonial from './TestimonialSection';
// import Breadcrumb from '../../components/Breadcrumb';
// import Contact from '../../components/Contact';
// import CTA from '../../components/CTA';
// import Brand from '../../components/Brand';
// import Team from './TeamSection';
// import Feature from './FeatureSection';
// import Work from './WorkSection';

// import aboutImg from '../../assets/img/about/about-6.png';
// import bgImg from '../../assets/img/cta/cta-bg-2.png';
// import videoBg from '../../assets/img/video/video-bg-4.png';
// import videoImg from '../../assets/img/video/video-bg-6.png';

// const HomeMain = () => {
//   return (
//     <main>
//       <Breadcrumb pageTitle="About Us" />

//       <Brand itemClass="brand-2__area brand-2__space" />

//       <div className="about-3__area about-3__space about-3__plr about-3__plr-2">
//         <div className="container-fluid">
//           <div className="row align-items-center">
//             <div
//               className="col-xl-6 col-lg-6 col-md-12 mb-70 wow animate__fadeInLeft"
//               data-wow-duration=".9s"
//               data-wow-delay=".3s"
//             >
//               <div className="about-3__item-img p-relative">
//                 <img src={aboutImg} alt="" />
//                 <div className="about-3__button about-3__button-wrapper d-flex align-items-center">
//                   <div className="about-3__video">
//                     <a href="#">
//                       <i className="fas fa-play"></i>
//                     </a>
//                   </div>
//                   <div className="about-3__video-text">
//                     <a href="#">
//                       <span>Watch Video</span>
//                     </a>
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div
//               className="col-xl-6 col-lg-6 col-md-12 mb-70 wow animate__fadeInRight"
//               data-wow-duration=".9s"
//               data-wow-delay=".5s"
//             >
//               <div className="about-3__item about-3__wrapper-item">
//                 <div className="about-3__section-title pb-10">
//                   <h4 className="section-blue-subtitle char-anim">
//                     Our About Now
//                   </h4>
//                   <h3 className="section-title char-anim">
//                     We Managing Laren About <br />
//                     Agency For <i>Business</i>.
//                   </h3>
//                 </div>
//                 <div className="about-3__content">
//                   <div className="about-3__text pb-7">
//                     <p className="char-anim-2">
//                       Business tailored it design, management & support services
//                       business agency elit, sed do eiusmod tempor.{' '}
//                     </p>
//                   </div>
//                   <div className="about-3__content-list about-3__content-list-2">
//                     <ul>
//                       <li>
//                         <i className="fal fa-check-square"></i>
//                         <span>
//                           Business sagittis aliquaenim minim veniam leo.
//                         </span>
//                       </li>
//                       <li>
//                         <i className="fal fa-check-square"></i>
//                         <span>We give management agency service. </span>
//                       </li>
//                       <li>
//                         <i className="far fa-angle-double-right"></i>
//                         <span>
//                           Business tailored it design, management & services.{' '}
//                         </span>
//                       </li>
//                     </ul>
//                   </div>
//                   <div className="about-3__button">
//                     <a className="main-btn-sm tp-btn-hover alt-color" href="#">
//                       <span>About More</span>
//                       <b></b>
//                     </a>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       <Feature />

//       {/* <Team /> */}

//       <Work />

//       <Testimonial />

//       <div className="funfact-2__area funfact-2__space">
//         <div
//           className="funfact-2__bg fix"
//           style={{ backgroundImage: `url(${videoBg})` }}
//         >
//           <div className="container">
//             <div className="row align-items-center">
//               <div className="col-xl-6 col-lg-6 col-md-7">
//                 <div className="funfact-2__content">
//                   <div
//                     className="funfact-2__text wow animate__fadeInUp"
//                     data-wow-duration=".9s"
//                     data-wow-delay=".3s"
//                   >
//                     <h4
//                       className="section-title text-white char-anim wow animate__fadeInUp"
//                       data-wow-duration=".9s"
//                       data-wow-delay=".5s"
//                     >
//                       Our Business Service <br />
//                       Apps of Agency.
//                     </h4>
//                   </div>
//                   <div
//                     className="funfact-2__button wow animate__fadeInUp"
//                     data-wow-duration=".9s"
//                     data-wow-delay=".7s"
//                   >
//                     <a className="border-btn-3 bg-color-1 mb-20 mr-15" href="#">
//                       <i className="fab fa-apple"></i> App Store
//                     </a>
//                     <a className="border-btn-3 bg-color-2 mb-20" href="#">
//                       <i className="fas fa-cloud"></i>Play Store
//                     </a>
//                   </div>
//                 </div>
//               </div>
//               <div className="col-xl-6 col-lg-6 col-md-5">
//                 <div
//                   className="funfact-2__main-img d-none d-md-block wow animate__fadeInUp"
//                   data-wow-duration=".9s"
//                   data-wow-delay=".9s"
//                 >
//                   <img src={videoImg} alt="" />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       <Contact />

//       <CTA ctaBG={bgImg} />
//     </main>
//   );
// };

// export default HomeMain;

import React from "react";
import Testimonial from "./TestimonialSection";
import Breadcrumb from "../../components/Breadcrumb";
import Contact from "../../components/Contact";
import CTA from "../../components/CTA";
import Feature from "./FeatureSection";
import Work from "./WorkSection";

import aboutImg from "../../assets/img/about/about-6.png";
import bgImg from "../../assets/img/cta/cta-bg.png";
import videoBg from "../../assets/img/video/video-bg-4.png";
import videoImg from "../../assets/img/video/video-bg-6.png";

const HomeMain = () => {
  return (
    <main>
      <Breadcrumb
        pageTitle="About PRD Infotech"
        description="PRD Infotech is a trusted technology partner, offering innovative software solutions, IT consulting, and digital transformation services. We help businesses streamline operations, enhance productivity, and achieve sustainable growth through cutting-edge technology. Our expertise ensures scalable, secure, and tailored solutions that drive success in the digital era."
      />

      {/* New Section: About PRD Infotech */}
      <div className="prd-info__section py-5">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <h2>About PRD Infotech Pvt Ltd</h2>
              <p>
                PRD Infotech Pvt Ltd is a leading technology company dedicated
                to empowering businesses with innovative software solutions. Our
                expertise covers ERP, CRM, production, asset management,
                barcoding, attendance, and inventory management systems, as well
                as cutting-edge mobile applications and custom software
                development. We pride ourselves on delivering quality,
                efficiency, and measurable results that drive digital
                transformation and business growth.
              </p>
              <p>
                With years of experience in the tech industry, we have
                successfully partnered with numerous clients to streamline their
                operations and boost productivity. Our team of seasoned
                professionals is committed to understanding your unique business
                challenges and delivering tailor-made solutions that not only
                meet but exceed your expectations.
              </p>
              <p>
                Innovation is at the core of our philosophy. We continuously
                invest in research and development to ensure that our solutions
                remain at the forefront of technology trends. By harnessing the
                power of the latest advancements, we enable our clients to
                optimize processes, enhance customer experiences, and achieve
                sustainable growth.
              </p>
              <p>
                Whether you are a small startup or a large enterprise, our
                comprehensive suite of services is designed to address the
                diverse needs of modern businesses. Partner with PRD Infotech
                and experience the difference that cutting-edge technology and
                expert support can make.
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* End of New Section */}

      <div className="about-3__area about-3__space about-3__plr about-3__plr-2">
        <div className="container-fluid">
          <div className="row align-items-center">
            {/* Left Side: Image */}
            <div
              className="col-xl-6 col-lg-6 col-md-12 mb-70 wow animate__fadeInLeft"
              data-wow-duration=".9s"
              data-wow-delay=".3s"
            >
              <div className="about-3__item-img p-relative">
                <img src={aboutImg} alt="About PRD Infotech" />
                {/*
                // Video overlay removed for now. Uncomment below for future use.
                <div className="about-3__button about-3__button-wrapper d-flex align-items-center">
                  <div className="about-3__video">
                    <a href="#">
                      <i className="fas fa-play"></i>
                    </a>
                  </div>
                  <div className="about-3__video-text">
                    <a href="#">
                      <span>Watch Video</span>
                    </a>
                  </div>
                </div>
                */}
              </div>
            </div>
            {/* Right Side: Content */}
            <div
              className="col-xl-6 col-lg-6 col-md-12 mb-70 wow animate__fadeInRight"
              data-wow-duration=".9s"
              data-wow-delay=".5s"
            >
              <div className="about-3__item about-3__wrapper-item">
                <div className="about-3__section-title pb-10">
                  <h4 className="section-blue-subtitle char-anim">
                    About PRD Infotech
                  </h4>
                  <h3 className="section-title char-anim">
                    Transforming Business Through Innovative Software Solutions.
                  </h3>
                </div>
                <div className="about-3__content">
                  <div className="about-3__text pb-7">
                    <p className="char-anim-2">
                      At PRD Infotech Pvt Ltd, we specialize in delivering
                      comprehensive digital solutions tailored to your business
                      needs. Our expertise spans ERP, CRM, production, asset
                      management, barcoding, attendance, and inventory
                      management software, as well as cutting-edge mobile
                      applications and custom software development.
                    </p>
                  </div>
                  <div className="about-3__content-list about-3__content-list-2">
                    <ul>
                      <li>
                        <i className="fal fa-check-square"></i>
                        <span>
                          Custom <strong>ERP</strong> &amp; <strong>CRM</strong>{" "}
                          solutions designed for your business.
                        </span>
                      </li>
                      <li>
                        <i className="fal fa-check-square"></i>
                        <span>
                          Robust <strong>Production</strong> and{" "}
                          <strong>Asset management</strong> systems.
                        </span>
                      </li>
                      <li>
                        <i className="fal fa-check-square"></i>
                        <span>
                          Innovative <strong>Mobile applications</strong> and{" "}
                          <strong>Tailored software</strong> services.
                        </span>
                      </li>
                      <li>
                        <i className="fal fa-check-square"></i>
                        <span>
                          Accurate <strong>Barcoding systems</strong> for
                          efficient tracking.
                        </span>
                      </li>
                      <li>
                        <i className="fal fa-check-square"></i>
                        <span>
                          Reliable <strong>Attendance management</strong> for
                          streamlined operations.
                        </span>
                      </li>
                      <li>
                        <i className="fal fa-check-square"></i>
                        <span>
                          Optimized <strong>Inventory management</strong> for
                          effective supply control.
                        </span>
                      </li>
                    </ul>
                  </div>
                  {/*
                  <div className="about-3__button">
                    <a className="main-btn-sm tp-btn-hover alt-color" href="/about">
                      <span>Learn More About Us</span>
                      <b></b>
                    </a>
                  </div>
                  */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Feature />

      {/* <Team /> */}

      <Work />

      <Testimonial />

      <div className="funfact-2__area funfact-2__space">
        <div
          className="funfact-2__bg fix"
          style={{ backgroundImage: `url(${videoBg})` }}
        >
          <div className="container">
            <div className="row align-items-center">
              {/* Left Side: Content */}
              <div className="col-xl-6 col-lg-6 col-md-7">
                <div className="funfact-2__content">
                  <div
                    className="funfact-2__text wow animate__fadeInUp"
                    data-wow-duration=".9s"
                    data-wow-delay=".3s"
                  >
                    <h4
                      className="section-title text-white char-anim wow animate__fadeInUp"
                      data-wow-duration=".9s"
                      data-wow-delay=".5s"
                    >
                      Innovative Mobile Solutions for a Connected World
                    </h4>
                  </div>
                  <div
                    className="funfact-2__button wow animate__fadeInUp"
                    data-wow-duration=".9s"
                    data-wow-delay=".7s"
                  >
                    <a
                      className="border-btn-3 bg-color-1 mb-20 mr-15"
                      href="/contact"
                    >
                      Get in Touch
                    </a>
                    {/*
                    // Additional App Store / Play Store buttons removed.
                    <a className="border-btn-3 bg-color-2 mb-20" href="#">
                      <i className="fas fa-cloud"></i>Play Store
                    </a>
                    */}
                  </div>
                </div>
              </div>
              {/* Right Side: Visual */}
              <div className="col-xl-6 col-lg-6 col-md-5">
                <div
                  className="funfact-2__main-img d-none d-md-block wow animate__fadeInUp"
                  data-wow-duration=".9s"
                  data-wow-delay=".9s"
                >
                  <img src={videoImg} alt="Mobile App Visual" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Contact />

      <CTA
        ctaBG={bgImg}
        Title="Empower Your Business with our Software Solutions"
        Description="Transform your operations with PRD Infotech’s innovative ERP, CRM, and custom software solutions. Our expertise streamlines processes, enhances productivity, and drives sustainable growth for your business."
      />
    </main>
  );
};

export default HomeMain;
